import React from 'react'
import Typography from '@material-ui/core/Typography'

interface YumMediumTitleProps {
  /**
   * The text content to display in the title
   */
  children: React.ReactNode

  /**
   * Additional styles to apply to the title
   */
  style?: React.CSSProperties
}

/**
 * Reusable medium title component with consistent styling.
 * Uses Material-UI Typography with predefined styles for medium-sized section titles.
 */
export default function YumMediumTitle({ children, style = {} }: YumMediumTitleProps) {
  return (
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 500, fontSize: 16, marginTop: 21, marginBottom: 11, ...style }}
    >
      {children}
    </Typography>
  )
}
